import React, { FC, useState, useCallback, memo, useEffect } from 'react'

import { styled } from '@mui/material';

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem';
import Collapse from '@mui/material/Collapse';
import Header from './Header'
import Body from './Body'

import { SelectChangeEvent } from '@mui/material'
import { GroupConditionOperator } from '../../types/GroupCondition'
import { useMultipleLocalizedText } from '../../context/Localization/localizationHooks';
import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks';
import { deleteGroup, updateGroupOperator, validateGroupCondition } from '../../store/groupConditionsSlice';
import { useViewModeReadOnly } from '../../context/ViewMode/viewModeHooks';

const RootContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    margin: '25px 0px',
    border: '1px solid #E4EDF3',
    width: '100%',
}))
export interface GroupContainerProps {
    groupIndex: number
    defaultExpanded?: boolean
    showDelete?: boolean
}
const Container: FC<GroupContainerProps> = (props) => {
    const validated = useAppSelector(({ groupConditions }) => groupConditions.validated)
    const groupCondition = useAppSelector(({ groupConditions }) => groupConditions.groupConditions[props.groupIndex])
    const dispatch = useAppDispatch()
    const isReadOnly = useViewModeReadOnly()
    const { CONDITIONLABEL, ADMINOPERATORAND, ADMINOPERATOROR } = useMultipleLocalizedText()

    const [expanded, setExpanded] = useState(props.defaultExpanded)

    const handleCollapse = useCallback(() => {
        setExpanded(false)
    }, [])

    const handleExpand = useCallback(() => {
        setExpanded(true)
    }, [])

    const handleDelete = useCallback(() => {
        dispatch(deleteGroup({ groupIndex: props.groupIndex }))
    }, [dispatch, props.groupIndex])

    const handleOperatorChange = useCallback((e: SelectChangeEvent) => {
        dispatch(updateGroupOperator({ groupIndex: props.groupIndex, newOperator: e.target.value as NonNullable<GroupConditionOperator> }))
    }, [dispatch, props.groupIndex])

    useEffect(() => {
        if (validated) {
            const errors = validateGroupCondition(groupCondition)

            // @ts-ignore
            if (errors && (errors.type !== '' || errors.length > 0)) {
                setExpanded(true)
            }
        }
    }, [validated])

    return (
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
            {groupCondition.operator !== null && (
                <Select
                    value={groupCondition.operator}
                    onChange={handleOperatorChange}
                    disabled={isReadOnly}
                >
                    <MenuItem value="AND">{ADMINOPERATORAND}</MenuItem>
                    <MenuItem value="OR">{ADMINOPERATOROR}</MenuItem>
                </Select>
            )}
            <RootContainer>
                <Header
                    label={(CONDITIONLABEL || `Condition {0}`).replace('{0}', String(Number(props.groupIndex + 1)))}
                    expanded={expanded}
                    showDelete={props.showDelete || false}
                    onCollapse={handleCollapse}
                    onExpand={handleExpand}
                    onDeleteGroupCondition={handleDelete}
                />
                <Collapse timeout="auto" in={expanded} unmountOnExit>
                    <Body groupIndex={props.groupIndex} />
                </Collapse>
            </RootContainer>
        </div>
    )
}

export default memo(Container, (prevProps, nextProps) => 
    prevProps.groupIndex === nextProps.groupIndex &&
    prevProps.defaultExpanded === nextProps.defaultExpanded &&
    prevProps.showDelete === nextProps.showDelete
)